import { NegotiableFieldRequired } from '../api'

export type AnyFunction = (...args: any[]) => any

export type Subtract<T, K> = Omit<T, keyof K>

export type primitive = string | number | boolean

export type DateLike = Date | string

export type PartialBy<T, K extends keyof T> = Omit<T, K> & { [P in K]?: T[P] }

export type Nullable<T> = T | null

export type KeysMatching<T, V> = { [K in keyof T]-?: T[K] extends V ? K : never }[keyof T]

export type Unpacked<T> = T extends (infer U)[] ? U : T

// These are manually defined types that are used in the application,
// typescript is not able to infer them due to generic type definition
// application defines its generic type but uses the raw type in a Map,
// unusual for java but valid case which is not supported by typescript-generator

export enum ReadAccess {
  READ = 'READ',
  READ_WRITE = 'READ_WRITE',
  INITIATOR_WRITE_RESPONDER_READ = 'INITIATOR_WRITE_RESPONDER_READ'
}

export interface NegotiationField {
  fieldType: ReadAccess | null
  negotiableFieldRequired: NegotiableFieldRequired<any> | null
}
